import { observable, transaction, computed } from 'mobx'
import Store from '../shared/store'
import { apiStore, AuthenticateMiddleware } from '../shared/api'
import { apiClient } from '../shared/api-impl'

import { auth as config } from '../config'

import ACService from './acservice'
import User from '../user/model'
import LoginError from './LoginError'

// function parsePermission(permission) {

//   if (permission === undefined) {
//     throw new Error(
//       'Permission needs to be defined!'
//     )
//   }

//   return permission.toUpperCase().split(',')

// }

@apiStore(apiClient)
class AuthStore extends Store {

  @observable user = null

  @observable error = null

  @computed get isLoggedIn() {
    return !!(this.user && this.user.id)
  }

  constructor(opts = {}) {

    super(opts)

    this.Model = User

    this.initAPIStore({
      ...opts,
      api: config.api,
    })

    this.acs = {}

  }

  ensureAuthenticated() {

    return new Promise((resolve) => {
      if (!this.loaded) {
        this.loadCurrentUser()
          .then(() => {
            this.loaded = true
            resolve(this.isLoggedIn)
          })
      }
      else {
        resolve(this.isLoggedIn)
      }
    })
  }

  // noop
  load(...args) {
    return this.api.load(...args)
  }

  save(...args) {
    return this.api.save(...args)
  }

  destroy(...args) {
    return this.api.destroy(...args)
  }

  impersonate(id, opts = {}, data = null) {
    if (!this.user.acs.isAuthorized('SUPERADMIN')) {
      throw new Error('Current user is no superadmin!')
    }
    opts.action = 'impersonate'
    opts.handleResult = (/*resId, resOpts, body*/) => {
      window.location.href = window.location.origin
    }
    return this.api.load(id, opts, data)
  }

  stopImpersonate() {
    return this.api.load(null, {
      action: 'stopImpersonate',
      handleResult(/*resId, resOpts, body*/) {
        window.location.href = window.location.origin
      }
    }, null)
  }

  setData(user = null, error = null) {
    transaction(() => {
      this.error = error
      this.user = user
    })
  }

  setUser(responseData) {

    if (!this.error || this.error instanceof LoginError) {
      const user = new User(this, responseData)
      this.acs = ACService.create(user.permissions)
      this.setData(user)
    }

  }

  handleError(err) {

    if (this.isLoginError(err)) {
      err = new LoginError(err)
    }
    else {
      // Log the error, otherwise it might go unnoticed!
      console.error(err)
    }

    let user = this.user
    if (!(err instanceof LoginError)) {
      user = null
    }

    this.setData(user, err)

  }

  isLoginError(err) {

    return !/TypeError|SyntaxError/.test(err.message || err)

  }

  deleteUser() {

    transaction(() => {
      delete this.user
      this.error = 'Logout'
    })
  }

  login(data) {

    if (this.error) {
      this.error = null
    }

    return this.api.client
      .post(this.api.getURL({ method: 'login' }), { data })
      .then((responseData) => this.setUser(responseData))
      .catch((err) => this.handleError(err))

  }

  loadCurrentUser() {

    return this.api.client
      .get(this.api.getURL({ method: 'me' }))
      .then((responseData) => this.setUser(responseData))
      .catch((err) => this.handleError(err))

  }

  logout() {

    return this.api.client
      .post(this.api.getURL({ method: 'logout' }), null)
      .then(() => this.deleteUser())
      .catch((err) => this.handleError(err))

  }

  handleUnauthorized() {

    // If there is still a User in the Store,
    // the application session timed out.
    if (this.user) {

      // This will cause a reload
      const url = window.location.pathname
      window.location.pathname = `${url}/`
    }
  }
}

export const authStore = new AuthStore()
apiClient.use(new AuthenticateMiddleware(authStore))



// WEBPACK FOOTER //
// ./src/auth/store.js